'use strict';
import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import forEach from 'lodash/forEach';
import forOwn from 'lodash/forOwn';
import keys from 'lodash/keys';
import {logger} from './logger';


// Legacy Angular Service
MiscUtils.$inject = [
];

export function MiscUtils() {
}

MiscUtils.prototype.blockPromise = blockPromise;
MiscUtils.prototype.bindToExit = bindToExit;
MiscUtils.prototype.eachPromise = eachPromise;
MiscUtils.prototype.compareStr = compareStr;
MiscUtils.prototype.verifyProperties = verifyProperties;

export function blockPromise(fn, ctx) {
  let called = false;
  const context = ctx || {};
  return function blockedCallback() {
    if (called) return;
    called = true;
    try {
      const result = fn.apply(context, arguments);

      if (result && isFunction(result.then)) {
        result.finally(calledFinally);
      } else {
        calledFinally();
      }

      return result;
    } catch (err) {
      calledFinally();
      logger.error({err});
      return Promise.reject(err);
    }
  };

  function calledFinally() {
    called = false;
  }
}

/**
 *
 * @param {$rootScope.Scope} $scope
 * @param {function} isDirty
 * @param {function} [onExit]
 */
export function bindToExit($scope, isDirty, onExit) {
  global.window.addEventListener('beforeunload', onbeforeunload);
  $scope.$on('$destroy', function () {
    global.window.removeEventListener('beforeunload', onbeforeunload);
  });
  // $scope.$on('$ionicView.leave', function () {
  //   window.removeEventListener('beforeunload', onbeforeunload);
  // });

  $scope.$on('$stateChangeStart', function(event) {
    if (isDirty()) {
      // eslint-disable-next-line max-len
      const answer = confirm('If you leave this page you are going to lose all unsaved changes, are you sure you want to leave?');
      if (!answer) {
        event.preventDefault();
      } else if (isFunction(onExit)) {
        onExit();
      }
    } else if (isFunction(onExit)) {
      onExit();
    }
  });

  function onbeforeunload(event) {

    // Check if there was any change, if no changes, then simply let the user leave
    if (!isDirty()){
      return;
    }

    const message = 'If you leave this page you are going to lose all unsaved changes, are you sure you want to leave?';
    if (isUndefined(event)) {
      event = window.event;
    }
    if (event) {
      event.returnValue = message;
    }
    return message;
  }
}

export function eachPromise(collection, callback, initialValue) {
  // validate inputs:
  if (!collection) throw new Error('must pass a collection to iterate over. received ', collection);
  if (!isFunction(callback)) throw new Error('must pass a callback function. received ', typeof callback);

  // create result
  let result, iterator, remaining;
  if (isArray(collection) || isString(collection)) {
    iterator = forEach;
    remaining = collection.length;
    result = [];
  } else if (isObject(collection)) {
    iterator = forOwn;
    remaining = keys(collection).length;
    result = {};
  } else {
    throw new Error('must pass a valid collection to iterate over. received ', collection);
  }

  // create wrapper promise
  const deferred = Promise.defer();

  // created initial promise
  const chainDeferred = Promise.defer();
  chainDeferred.resolve(initialValue);
  let prevPromise = chainDeferred.promise;

  iterator(collection, function (value, key, collection) {
    prevPromise = prevPromise.then(function (resolvedValue) {
      const q = Promise.defer();
      q.resolve(callback(value, key, collection, resolvedValue));

      q.promise.then(function (returnedValue) {
        remaining -= 1;
        result[key] = returnedValue;

        if (remaining > 0) {
          return returnedValue;
        } else {
          deferred.resolve(result);
        }
      });

      return q.promise;
    });
  });

  return deferred.promise;
}

export function compareStr(stra, strb) {
  stra = ("" + stra).toLowerCase();
  strb = ("" + strb).toLowerCase();
  return stra.indexOf(strb) !== -1;
}

/**
 * Verify that an object contains the provided list of properties.
 * @param object
 * @param properties
 * @param {string} objectName - object
 * @returns {boolean}
 */
export function verifyProperties(object, properties, objectName) {
  let message = 'Expected object.% to exist!';
  if (isString(objectName)) {
    message = message.replace('object', objectName);
  }

  forEach(properties, key => {
    if (isNil(object[key])) {
      throw new Error(message.replace('%', key));
    }
  });

  return true;
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/misc-utils/MiscUtils.js